/**
 * @typedef {(IDLE)} TypeAnimation An animation.
 */

/**
 * The 'IDLE' animation.
 * @type {'idle'}
 * @constant
 */
const IDLE = 'idle';

export {

    IDLE
};
